// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gradient-text {
  background-image: linear-gradient(
    var(--gradient-angle, 90deg),
    var(--gradient-from, #e11d2e),
    var(--gradient-to, #ffffff)
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  display: inline-block;
}
`, "",{"version":3,"sources":["webpack://./src/components/GradientText.css"],"names":[],"mappings":"AAAA;EACE;;;;GAIC;EACD,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;AACvB","sourcesContent":[".gradient-text {\n  background-image: linear-gradient(\n    var(--gradient-angle, 90deg),\n    var(--gradient-from, #e11d2e),\n    var(--gradient-to, #ffffff)\n  );\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
